module.exports = __webpack_public_path__ + "static/media/hall-void.904ad7b0.svg";